import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { TokenService } from './token.service';
declare var AwsWafIntegration: any;
@Injectable({ providedIn: 'root' })
export class InitializeScriptService {
    private configData: any;
    public readonly host: string;
    private googleMapTokenEndpoint = '';
    private readonly GET_API: string = `token-service/public?tokenName=:keyName`;    
  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentConfiguration,
    private _tokenService: TokenService
  ) {   
     this.googleMapTokenEndpoint = `${this.environmentService.RTI_ENDPOINT}/${this.GET_API}`;
    }
    private initScript(url: string): HTMLScriptElement {
    const scriptToAppend: HTMLScriptElement = document.createElement('script');
    scriptToAppend.src = url;
    scriptToAppend.defer = true;
    scriptToAppend.async = true;
    document.querySelector('head').appendChild(scriptToAppend);    
    return scriptToAppend;
  }

  public getApiToken() {
    return new Promise((resolve, reject) => {
        const script = this.initScript(`${this.environmentService.WAF_URL}challenge.js`);
        script.onload = () => {
            // Wait until AWS auth token is available, adjust based on your global token variable
            this.loadGoogleMaps();
            const checkToken = () => {
                AwsWafIntegration.getToken().then((token: string) => {
                        const url = this.googleMapTokenEndpoint.replace(':keyName', 'vspec');
                        let headers = new HttpHeaders();
                        headers.set('Content-Type', 'application/json');
                        headers = headers.set('X-Aws-Waf-Token', token);

                        this.http.get<any>(url, { headers })
                        .subscribe(
                            (apiresponse: any) => {;
                            this.configData = apiresponse;
                            console.log("Got the API KEY");
                            resolve(true);                            
                            },
                            (error: any) => {
                                console.log("error vspec api");
                                resolve(true);
                            }
                        );
                    }).catch((error: any) => {
                        console.log("error vspec api");
                        resolve(true);
                    });
            };
    checkToken();
  };})
  }

  getConfig() {
    return this.configData;
  }

    private loadGoogleMaps() {
    this._tokenService.getGoogleMapsToken()
      .subscribe(
        (res: any) => {
          let googleKey = '';
          if (res && res.tokenDetails && res.tokenDetails.apiKey) {
            googleKey = res.tokenDetails.apiKey;
            const googleMapsScript = this.initScript(`https://maps.googleapis.com/maps/api/js?key=${googleKey}`);
            googleMapsScript.onload = () => {
              this._tokenService.isMapLoaded$.next(true);
            }
          } else {
            this._tokenService.isMapLoadedError$.next(true);
          }
        },
        (error: any) => {
          console.error('Error getting Google Maps token:', error);
        }
    );
  }
}